<template>

    <FloatingPanel :title="title" :width="calculatedWidth">

        <div class="canvas::editor-website-editors-loop-owlCarousel-LoopItemPanel">

            <slot/>

            <div class="m-5">

                <div class="mb-1 text-gray-600">Positie van slide</div>

                <small class="block mb-3 text-gray-500 text-muted">Bepaal in welke volgorde deze slide in de slider getoond wordt.</small>

                <div class="flex">

                    <button
                        class="btn btn-blue"
                        :class="{ 'opacity-50': loopIndex == 0 }"
                        :disabled="loopIndex == 0"
                        @click="mutateIndex(-1)">
                        <i class="mr-1 fa fa-arrow-left"></i>
                        Verplaats terug
                    </button>

                    <button
                        class="ml-3 btn btn-blue"
                        :class="{ 'opacity-50': loopIndex == loopItems.length - 1 }"
                        :disabled="loopIndex == loopItems.length - 1"
                        @click="mutateIndex(1)">
                        Verplaats verder
                        <i class="ml-1 fa fa-arrow-right"></i>
                    </button>

                </div>

                <small class="block mt-4 mb-2 text-gray-500">Of verplaats naar specifieke positie</small>
                <div class="flex w-full">
                    <span class="inline-flex items-center px-2 py-1 bg-gray-100 border rounded-l">
                        Verplaats naar plek
                    </span>
                    
                    <input v-model="targetPosition" type="number" min="1" :max="loopItems.length" 
                        class="flex-1 text-center border border-l-0 border-gray-300 min-w-32"
                        :placeholder="'Huidig: ' + (loopIndex + 1)"
                    />

                    <button class="btn btn-blue !rounded-l-none" @click="moveToPosition(targetPosition - 1)" :disabled="targetPosition <= 0 || targetPosition > loopItems.length">
                        Pas toe
                    </button>
                </div>

            </div>

        </div>

        <template v-slot:actions>
            <slot name="actions">
                <div class="flex defaultActions">

                    <slot name="actionsExtra"></slot>

                    <button
                        class="inline-flex justify-center w-full py-3 text-white bg-red-400 rounded-none"
                        @click="removeItem">
                        <i class="mr-1 fa fa-trash"></i> Verwijder
                    </button>

                </div>

            </slot>
        </template>

    </FloatingPanel>

</template>

<script>

import LoopItemPanel from "../LoopItemPanel";
import FloatingPanel from "../../panels/FloatingPanel";

export default {
    extends: LoopItemPanel,
    components: {
        FloatingPanel,
    },
    props: {
        title: {
            type: String,
            default() {
                return this.$parent.selection.currentSelection.editableData?.label || 'Slide';
            },
        },
        width: Number,
    },
    data() {
        return {
            targetPosition: null, // For user input to move to specific position
        };
    },
    methods: {
        mutateIndex(mutation) {
            // Existing logic for swapping adjacent items
            let swapWithIndex = this.loopIndex + mutation;
            if (swapWithIndex < 0) swapWithIndex = this.loopItems.length - 1;
            else if (swapWithIndex > this.loopItems.length - 1) swapWithIndex = 0;

            this.swapItems(swapWithIndex);
        },

        moveToPosition(targetIndex) {
            // Check if targetIndex is within valid range
            if (targetIndex < 0 || targetIndex >= this.loopItems.length) {
                return;
            }

            this.swapItems(targetIndex);
        },

        swapItems(targetIndex) {
            let originals = {
                loopIndex2canvasBlocks: {},
                loopItems: [...this.loopItems],
            };

            for (let child of this.loopEditorComponent.$children) {
                originals.loopIndex2canvasBlocks[child.loopIndex] = child.canvasBlocks;
            }

            for (let swap of [
                [targetIndex, this.loopIndex],
                [this.loopIndex, targetIndex]
            ]) {
                for (let canvasBlock of originals.loopIndex2canvasBlocks[swap[0]]) {
                    let keySuffix = canvasBlock.key.split('.').slice(2).join('.');
                    this.$set(canvasBlock, 'key', this.loopKey + '.' + swap[1] + '.' + keySuffix);
                }

                this.$set(this.loopItems, swap[0], originals.loopItems[swap[1]]);
            }

            let newSelection = this.loopEditorComponent.getLoopItemEditorByIndex(targetIndex);
            this.$pageComponent().selection.setSelection(newSelection);
        },
    },
};


</script>

<style lang="scss" scoped>

.canvas\:\:editor-website-editors-loop-owlCarousel-LoopItemPanel {

    .actions:first-child {
        @apply pt-3;
    }

}

</style>
